import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import First from "./First_section/First";
import Second from "./Second_section/Second";
import Third from "./Third_section/Third";
import CareersSection from "../../WhoweAre/ContectUs/CareersSection";

const IndusAutomation = () => {
  return (
    <>
      <Header />
      <First />
      <Second />
      <Third />
      <CareersSection />
      <Footer />
    </>
  );
};

export default IndusAutomation;
